export const AUTH_TYPE = {
  Internal: 'OneAccount',
  External: 'auth0',
};

export type WebConfig = {
  clientId: string;
  scope: string;
  domain: string;
  audience: string;
  oneAccountConnection: string;
  env: string;
  maintenance: boolean;
};

export const ENV_LABEL = {
  dev: '開発環境',
  test: 'テスト環境',
  preprod: 'プリプロッド環境',
  offline: 'Offline',
} as Record<string, string>;
